module.exports = __webpack_public_path__ + "static/media/Portrait-10014.842ba108.jpg";